

function StatBox(props) {
    return (
        <div className="pb-5 pr-8">
            <h2 className="text-lg font-semibold text-app_blue ">{props.title}</h2>
            {(
                props.version === 0 ?
                 <div className="min-w-32 px-3 text-white bg-gradient-to-r from-app_green to-app_blue   font-bold rounded-[10px] text-lg p-0.5 text-center">
                {props.number}
                </div> 
                
                
                : 
                
                <div className="min-w-32 px-3 text-white bg-gradient-to-r from-app_brown to-app_yellow   font-bold rounded-[10px] text-lg p-0.5 text-center">
                    {props.number}</div>
            )}

            {/* {(
                props.version === 0 ?
               <div className="w-32 p-1 rounded-2xl bg-gradient-to-r from-app_green to-app_blue">  
               <div className="w-31 text-app_green_light bg-white   font-bold rounded-2xl text-xl text-center">
                {props.number}
                </div> 
                </div>
                
                
                : 
                
                <div className="w-32 p-1 rounded-2xl bg-gradient-to-r from-app_brown to-app_yellow">  
               <div className="w-31 text-app_green_light bg-white   font-bold rounded-2xl text-xl text-center">
                {props.number}
                </div> 
                </div>
            )} */}
        </div>
    );
}

export default StatBox;
